export default __webpack_public_path__ + "static/asl-icon-c797b4f3ff060e0c899b2442d34c531c.png";